import React from 'react';
import styles from 'styles/layout/FAQHeader.module.sass';

/**
 * FAQHeader component - A header section for the FAQ page.
 *
 * @component
 * @returns {JSX.Element} The rendered FAQHeader component.
 *
 * @example
 * // Example usage:
 * <FAQHeader />
 */
const FAQHeader: React.FC = () => (
  <div className={styles['faq-header-section']}>
    <p className={styles['faq-title']}>Frequently Asked Questions</p>
    <p className={styles['faq-subtitle']}>
      Find quick answers to common questions about our reports, pricing, access, and more.
      If you can&apos;t find what you&apos;re looking for, we&apos;re just a message away.
    </p>
  </div>
);

export default FAQHeader;
